import { Component, OnInit, OnDestroy } from '@angular/core';

import { Observable ,  Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import * as jp from "jsonpath/jsonpath";

import { ReportSelectorService } from '../../../services/report-selector.service';
import { BaseControlComponent } from '../../base-control/base-control.component';
import { ReportingService } from '../../../../common/services/reporting.service';
import { ContextInteractionService } from '../../../services/context-interaction.service';
import { IReportContextValue, ReportTemplate } from '../../../../models/comodel/mergefieldsmodel.model';


@Component({
    selector: 'app-report-template-selector',
    templateUrl: './report-template-selector.component.html',
    standalone: false
})
export class ReportTemplateSelectorComponent extends BaseControlComponent implements OnInit, OnDestroy {
    static componentName = 'ReportTemplateSelectorComponent';
    
    allowSelection: boolean = false;
    isReport: boolean = false;
    selectedTemplate: ReportTemplate;
    templates: Observable<Array<ReportTemplate>>;

    public selectedTemplateSubscription: Subscription;
    public _templates: Array<ReportTemplate> = new Array<ReportTemplate>();

    constructor(public reportSelectorService: ReportSelectorService,
                public reportService: ReportingService,
                public readonly contextService: ContextInteractionService)
    {
        super(contextService);
    }

    ngOnInit(): void {
        this.templates = this.reportSelectorService.getAllTemplates().pipe(tap(value => {

            let template;
            if (this.componentContext) {
                template = jp.value(this.componentContext, '$.data.reportFlow');
            } 
            
            if (this.reportService.data['template']) {
                this.isReport = true;
                template = this.reportService.data['template'];
                jp.value(this.componentContext, '$.reporting.allowedSignerTypes', template.allowedSignerTypes);
                jp.value(this.componentContext, '$.reporting.templateId', template.id);
            } else {
                this.allowSelection = true;
            }

            if (template)
                this.selectedTemplate = template;

            this._templates = value;

            if (this.selectedTemplate)
                this._templates[this._templates.findIndex(x => x.id === this.selectedTemplate.id)] = this.selectedTemplate;

            //TODO Commented out for now because we're not worrying about the flow based stuff.
            //this.onTemplateSelect(this.selectedTemplate.id);
        }));
    }

    ngOnDestroy(): void {
        if (this.flowComponent)
            this.flowComponent.workflow.saveContext();

        if (this.selectedTemplateSubscription)
            this.selectedTemplateSubscription.unsubscribe();

        this.reportService.setData({});
    }

    onContextValueChange(text: string, contextValue: any): void {
    //TODO Commented out for now because we're not worrying about the flow based stuff.
        //let onChange = this.selectedTemplate.onChanges.find(x => x.name === contextValue);

        //if (onChange)
        //    onChange.subject.next(text);
    }

    //TODO Commented out for now because we're not worrying about the flow based stuff.
    onTemplateSelect(reportId: string): void {
    //    let selectedReportTemplate = this._templates.find(x => x.id === reportId) as ReportTemplate;

    //    if (!selectedReportTemplate)
    //        return;

    //    if (this.componentContext)
    //        this.writeSelectedTemplateToContext(selectedReportTemplate);

    //    let previousContextValues = Object.assign([], selectedReportTemplate.reportContextValues);

    //    selectedReportTemplate.reportContextValues = new Array<IReportContextValue>();
    //    this.selectedTemplate = selectedReportTemplate;
 
    //    for (let contextTarget of selectedReportTemplate.reportContextValues) {
    //        let previousContextValue: IReportContextValue = previousContextValues.find(x => x.context.contextValue === contextTarget.replaceValue);
    //        let newContextValue: IReportContextValue = { displayName = "", replaceTarget = "", replaceValue = "", onBaseKeywordName = "" };

    //        if (previousContextValue)
    //            newContextValue = previousContextValue;
    //        else {
    //            newContextValue.replaceTarget = contextTarget;

    //            if (this.isReport) {
    //                const value = this.getProperty(contextTarget.replaceValue, this.reportService.data);
    //                newContextValue.replaceValue = value || '';
    //                this.reportService.addToken({ key: contextTarget.replaceValue, value: newContextValue.value})
    //                this.updateContextDotReporting(contextTarget.replaceValue, value);
    //                this.flowComponent.workflow.saveContext();
    //            } else {                    
    //                newContextValue.replaceValue = jp.value(this.componentContext, ReportingService.ReportContextPrefix + contextTarget.replaceValue) || '';
    //            }
    //        }

    //        let newSubscription: { name: string, subject: Subject<string> } = { name: newContextValue.context.replaceValue, subject: new Subject<string>() };

    //        newSubscription.subject.asObservable().pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
    //            this.updateContextDotReporting(contextTarget.replaceValue, value);
    //            this.flowComponent.workflow.saveContext();
    //            newContextValue.value = value;
    //        });

    //        selectedReportTemplate.reportContextValues.push(newContextValue);
    //    }

    //    this.reportSelectorService.updateSelected(this.selectedTemplate);
    }

    public getProperty(path, obj) {
        return path.split('.').reduce(function(prev, curr) {
            return prev ? prev[curr] : null
        }, obj || self)
    }

    public updateContextDotReporting(key: string, value: string): void {
        jp.value(this.componentContext, ReportingService.ReportContextPrefix + key, value);
    }

    public writeSelectedTemplateToContext(selectedReportTemplate: ReportTemplate, resetInstantiated: boolean = false): void {
        let context = jp.value(this.componentContext, '$.data.reportFlow');
        let report = Object.assign({}, context, selectedReportTemplate);

        if (resetInstantiated)
            report.instantiatedId = undefined;

        report.onChanges = [];

        jp.value(this.componentContext, '$.data.reportFlow', report);
    }
}